const VideoIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
    >
      <path
        d="M15.387 24.4416H8.01372C4.32705 24.4416 3.10205 21.9916 3.10205 19.5299V9.70659C3.10205 6.01992 4.32705 4.79492 8.01372 4.79492H15.387C19.0737 4.79492 20.2987 6.01992 20.2987 9.70659V19.5299C20.2987 23.2166 19.062 24.4416 15.387 24.4416Z"
        stroke="#015C9A"
        stroke-width="1.64384"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M23.5407 20.5673L20.2974 18.2923V10.9307L23.5407 8.65567C25.1274 7.54734 26.434 8.22401 26.434 10.1723V19.0623C26.434 21.0107 25.1274 21.6873 23.5407 20.5673Z"
        stroke="#015C9A"
        stroke-width="1.64384"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export default VideoIcon;
